module.exports = __webpack_public_path__ + "static/media/Advice.c08c54ad.png";